import { render, staticRenderFns } from "./ChannelSummaryEdit.vue?vue&type=template&id=1368d4a2"
import script from "./ChannelSummaryEdit.vue?vue&type=script&lang=js"
export * from "./ChannelSummaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports